import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography, Paper } from '@mui/material';

import { FilterControls, MuiSelect } from '../protected/scholarshipApplication/components';
import { useStyles } from './styles';
import RenderIf from '../renderIf';

const ListFilters = ({ filters, isFetching, handleFilterChange, handleClearFilters }) => {
    const classes = useStyles();
    const handleResetToDefault = () => {};
    const handleSaveNewDefault = () => {};

    return (
        <Box className={classes.filtersWrapper}>
            <Paper>
                <Box className={classes.paper}>
                    <Box className={classes.flexCenter}>
                        <Typography variant="h2">Filters</Typography>
                        <FilterControls
                            handleClearFilters={handleClearFilters}
                            handleResetToDefault={handleResetToDefault}
                            handleSaveNewDefault={handleSaveNewDefault}
                            isDefaultFilters={true}
                        />
                    </Box>
                </Box>
                <RenderIf isTrue={!!filters?.length}>
                    <Box className={`${classes.flexCenter} ${classes.currentFiltersWrapper}`}>
                        {filters?.map((filter) => (
                            <Box>
                                <MuiSelect
                                    {...filter}
                                    handleChange={handleFilterChange}
                                    isMultipleSelection
                                />
                            </Box>
                        ))}
                        <RenderIf isTrue={isFetching}>
                            <CircularProgress />
                        </RenderIf>
                    </Box>
                </RenderIf>
            </Paper>
        </Box>
    );
};

export default ListFilters;
